import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { post } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";

function CreateDepartmentModal({ isOpen, toggle, refreshSettings, departmentToEdit }) {
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = useState(false);
  const [sourceData, setSourceData] = useState({
    name: departmentToEdit?.name || null,
  });

  useEffect(() => {
    if(departmentToEdit) {
      setSourceData({
        name: departmentToEdit?.name || null,
      });
    } else {
      setSourceData({
        name: null,
      });
    }
  }, [departmentToEdit, isOpen]);

  const saveDepartment = async () => {
    setSaveLoading(true);
    const url = departmentToEdit ? `/hr/departments/update/${departmentToEdit.id}` : '/hr/departments/store';
    const data = await post(url, sourceData)
    if(data?.success) {
      refreshSettings();
      toggle();
      toast.success(departmentToEdit ? t('alerts.success_update') : t('alerts.success_create'));
    } else {
      toast.error(data?.message || t('alerts.error'));
      toggle();
    }
    setSaveLoading(false);
  }

  return(
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader toggle={toggle}>
        {departmentToEdit ? t('hr.settings.departments.edit') : t('hr.settings.departments.create_new')}
      </ModalHeader>

      <ModalBody>
        <FormGroup>
          <Label>{t('common.name')}: </Label>
          <Input 
            value={sourceData?.name}
            onChange={e => setSourceData({...sourceData, name: e.target.value})}
          />
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <DefaultButton color="secondary" size="sm" outline onClick={toggle}>{t('common.cancel')}</DefaultButton>
        <DefaultButton 
          color="primary" 
          size="sm" 
          onClick={saveDepartment}
          loading={saveLoading}
          disabled={saveLoading || !sourceData?.name}
        >{t('common.save')}</DefaultButton>
      </ModalFooter>
    </Modal>
  );
}

export default CreateDepartmentModal;